const KeyMessagesArchive = (keyMessagesButton) => {
    const blockContent = document.querySelector('.archive-key-messages__body');


    if (typeof keyMessagesButton != "undefined" && keyMessagesButton != null && typeof blockContent != "undefined" && blockContent != null) {
        keyMessagesButton.addEventListener('click', () => {
            blockContent.scrollIntoView({ behavior: 'smooth' });
        });
    }
}

export default KeyMessagesArchive;
